module.exports = __webpack_public_path__ + "cbec3f0caa94ee95876f0021228ec4b9.jpg";